import { render, staticRenderFns } from "./StateAnswerWriting.vue?vue&type=template&id=336f55d4&scoped=true&lang=html&"
import script from "./StateAnswerWriting.vue?vue&type=script&lang=coffee&"
export * from "./StateAnswerWriting.vue?vue&type=script&lang=coffee&"
import style0 from "./StateAnswerWriting.vue?vue&type=style&index=0&id=336f55d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336f55d4",
  null
  
)

component.options.__file = "StateAnswerWriting.vue"
export default component.exports